var sipStack;
var oSipSessionCall;
var calleventsListener;
var registerSession;
var Asterisk_RealM;
var imp_i;
var imp_u;
var passwor_d;
var websocketproxyurl;
var asteriskConnectCallBackEventListner;
var registerCallBackEventListner;
var connectingCallBackEventListner;
var readyCallback = function (e) {
  //createSipStack(); // see next section
};
var errorCallback = function (e) {
  console.error('Failed to initialize the engine: ' + e.message);
};
SIPml.init(readyCallback, errorCallback);
function AsteriskConnect(AsteriskRealm, AsteriskIP, AsteriskPort, User, Password, eventListner) {
  asteriskConnectCallBackEventListner = eventListner;
  Asterisk_RealM = AsteriskRealm;
  imp_i = User;
  imp_u = 'sip:' + User + '@' + AsteriskIP; //impu: 'sip:TLT01@10.112.1.181'
  console.log(new Date().toLocaleString() + '  ➤  IP: ' + AsteriskIP);
  passwor_d = Password;
  websocketproxyurl = 'wss://' + AsteriskIP + ':' + AsteriskPort + '/ws'; //'wss://10.112.1.181:8089/ws', // optional
  var eventsListener = function (e) {
    asteriskConnectCallBackEventListner(e);
    console.info('start stack event = ' + e.type);
  };
  // function showNotifICall(s_number) {
  // // permission already asked when we registered
  // if (window.webkitNotifications && window.webkitNotifications.checkPermission() == 0) {
  // if (oNotifICall) {
  // oNotifICall.cancel();
  // }
  // oNotifICall = window.webkitNotifications.createNotification('images/sipml-34x39.png', 'Incaming call', 'Incoming call from ' + s_number);
  // oNotifICall.onclose = function () { oNotifICall = null; };
  // oNotifICall.show();
  // }
  //}

  //function createSipStack(){
  sipStack = new SIPml.Stack({
    realm: Asterisk_RealM, //'10.111.32.163', // mandatory: domain name
    impi: imp_i, //'TLT01', // mandatory: authorization name (IMS Private Identity)
    impu: imp_u, //'sip:TLT01@10.111.32.163', // mandatory: valid SIP Uri (IMS Public Identity)
    password: passwor_d, //'malcolm', // optional
    display_name: imp_i, //'TLT01', // optional
    websocket_proxy_url: websocketproxyurl, //'wss://10.111.32.163:8089/ws', // optional
    enable_rtcweb_breaker: false, // optional
    ice_servers: [],
    events_listener: { events: '*', listener: eventsListener }, // optional: '*' means all events
    sip_headers: [
      // optional
      { name: 'User-Agent', value: 'WebSoft Phone' },
      { name: 'Organization', value: 'IbexGloabal' },
    ],
  });
  //}
  sipStack.start();
}
function AsteriskRegister(eventListner) {
  registerCallBackEventListner = eventListner;
  var registereventsListener = function (e) {
    console.info('register session event = ' + e.type);
    //document.getElementById("register").innerHTML = "Register Events : " + e.type;

    registerCallBackEventListner(e);
  };

  registerSession = sipStack.newSession('register', {
    events_listener: { events: '*', listener: registereventsListener }, // optional: '*' means all events
  });
  registerSession.register();
}
function AsteriskUnRegister() {
  registerSession.unregister();
  registerSession = null;
}
function AsteriskDisconnect() {
  if (sipStack) {
    sipStack.stop(); // shutdown all sessions
  }
  sipStack = null;
  registerSession = null;
  oSipSessionCall = null;
}

function establishVoiceConnection(DNIS, callBackEventListner) {
  connectingCallBackEventListner = callBackEventListner;
  calleventsListener = function (e) {
    console.info('call session event = ' + e.type);
    connectingCallBackEventListner(e);
  };
  if (sipStack) {
    oSipSessionCall = sipStack.newSession('call-audio', {
      audio_remote: document.getElementById('audio_remote'),
      events_listener: { events: '*', listener: calleventsListener }, // optional: '*' means all events
    });
  } else {
    console.log(new Date().toLocaleString() + ' | Please Connect First');
    //txtRegistarStatus.innerHTML = '<i>Please register First....</i>';
    return -1;
  }

  if (oSipSessionCall.call(DNIS) != 0) {
    oSipSessionCall = null;
    console.error('Failed to make call');
    //txtCallStatus.value = 'Failed to make call';
    return -1;
  }
}
function onAcceptCall() {
  //if(oSipSessionCall)
  //	oSipSessionCall.accept();
}

function HangUpCall() {
  console.log(new Date().toLocaleString() + ' | voice phone hangup');
  if (oSipSessionCall) oSipSessionCall.hangup({ events_listener: { events: '*', listener: calleventsListener } });
}
function MuteCall() {
  if (oSipSessionCall) {
    result = oSipSessionCall.mute('audio', true);
    oSipSessionCall.bMute = true;
    return result;
  }
}
function UnMuteCall() {
  if (oSipSessionCall) {
    var result = oSipSessionCall.mute('audio', false);
    oSipSessionCall.bMute = false;
    return result;
  }
}
function sipSendDTMF(c) {
  if (oSipSessionCall && c) {
    return oSipSessionCall.dtmf(c);
  }
}
function sendDtmfString(str) {
  if (str) {
    for (var i = 0, len = str.length; i < len; i++) {
      var ret = sipSendDTMF(str[i]);
      if (ret != 0) return ret;
    }
    return 0;
  }
  return 1;
}
